import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Smartphone, Archive, FileCheck, Clock, Building2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    title: 'Informes en minutos',
    description: 'Cada visita se convierte en un informe profesional.',
    icon: <Zap className="w-6 h-6 text-blue-600" data-id="element-20" />
  }, {
    title: 'Sin apps nuevas',
    description: 'Funciona desde WhatsApp. Sin descargas.',
    icon: <Smartphone className="w-6 h-6 text-blue-600" data-id="element-21" />
  }, {
    title: 'Historial completo',
    description: 'Visitas e informes organizados y accesibles.',
    icon: <Archive className="w-6 h-6 text-blue-600" data-id="element-22" />
  }, {
    title: 'Informes profesionales',
    description: 'Listos para enviar a clientes y mandantes.',
    icon: <FileCheck className="w-6 h-6 text-blue-600" data-id="element-23" />
  }, {
    title: 'Ahorra horas',
    description: 'Elimina el trabajo de escritorio post-visita.',
    icon: <Clock className="w-6 h-6 text-blue-600" data-id="element-24" />
  }, {
    title: 'Multi-obra',
    description: 'Múltiples proyectos en un solo lugar.',
    icon: <Building2 className="w-6 h-6 text-blue-600" data-id="element-25" />
  }];
  return <section className="py-16 sm:py-24 bg-white" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="text-center mb-12 sm:mb-16" data-id="element-28">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900" data-id="element-29">
            ¿Por qué InspectIA?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-30">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-31">
              <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center mb-4" data-id="element-32">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-33">
                {benefit.title}
              </h3>
              <p className="text-gray-600" data-id="element-34">{benefit.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}